// core
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@ngneat/transloco';
import { BreadcrumbComponent } from './breadcrumb.component';

// share

const core = [CommonModule, TranslocoModule];
const component = [BreadcrumbComponent];

@NgModule({
  imports: [...core],
  declarations: [...component],
  exports: [...component],
})
export class BreadcrumbModule {}
